import {
  Input,
  Select,
  ActionIcon,
  Flex,
  Anchor,
  Text,
} from '@mantine/core'
import { IconSearch, IconX } from '@tabler/icons-react'
import { useArcTranslation } from 'hooks'

interface Props {
  search: string
  onSearchChange: (value: string) => void
  selectedGroupId: string | null
  onGroupChange: (value: string | null) => void
  groupOptions: Array<{ value: string; label: string }>
}

export function StudentFilters({
  search,
  onSearchChange,
  selectedGroupId,
  onGroupChange,
  groupOptions,
}: Props) {
  const { t } = useArcTranslation()

  return (
    <>
      <Flex align='center' gap='sm' mt='md'>
        <Input
          icon={<IconSearch />}
          placeholder={t('manage_students.search_placeholder')}
          size='md'
          radius='xl'
          value={search}
          onChange={
            (e: React.ChangeEvent<HTMLInputElement>) =>
              onSearchChange(e.currentTarget.value)
          }
          rightSection={
            search.length > 0 && (
              <ActionIcon
                onClick={() => onSearchChange('')}
                mr={24}
              >
                <IconX />
              </ActionIcon>
            )
          }
          sx={{ flex: 1 }}
        />
        {search.length > 0 && (
          <Anchor
            component='button'
            size='sm'
            onClick={() => onSearchChange('')}
          >
            {t('manage_students.clear_filter')}
          </Anchor>
        )}
      </Flex>

      <Flex align='center' gap='sm' wrap='wrap' mt='sm'>
        <Text size='sm' fw={600}>
          {t('manage_students.filter_by_group')}
        </Text>
        <Select
          placeholder={t('manage_students.all_groups')}
          data={groupOptions}
          value={selectedGroupId}
          onChange={onGroupChange}
          clearable
          size='sm'
          sx={{ minWidth: 180 }}
        />
        {selectedGroupId && (
          <Anchor
            component='button'
            size='sm'
            onClick={() => onGroupChange(null)}
          >
            {t('manage_students.clear_filter')}
          </Anchor>
        )}
      </Flex>
    </>
  )
}
